import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchSubscriptionBalance = () => {
  return {
    types: [
      actionTypes.FETCH_ACCOUNT_BALANCE_LOADING,
      actionTypes.FETCH_ACCOUNT_BALANCE_SUCCESS,
      actionTypes.FETCH_ACCOUNT_BALANCE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/balance`,
      }),
  };
};

export const fetchRecordedBalance = () => {
  return {
    types: [
      actionTypes.FETCH_RECORDED_BALANCE_LOADING,
      actionTypes.FETCH_RECORDED_BALANCE_SUCCESS,
      actionTypes.FETCH_RECORDED_BALANCE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/balance?breakdown=recorded_balance`,
      }),
  };
};
